module.exports = __webpack_public_path__ + "img/invoice2.5eb81f88.png";